/* global localStorage */
const DEVICE_KEY = 'RISTORANTI.IT@@@DEVICE_UUID';

const UUID = () => {
  const current = localStorage.getItem(DEVICE_KEY);
  if (current) return current;

  // generate new UUID
  const newUUID = `widget_${(Math.random()).toString(16)}`;
  localStorage.setItem(DEVICE_KEY, newUUID);
  return newUUID;
};

export default {
  UUID,
};



// WEBPACK FOOTER //
// ./src/lib/device.js